import React, { useCallback, useEffect, useState } from 'react'
import { StyleSheet } from 'react-native'
import { Utils } from '@vatom/sdk/core'

import { FaceProps, placeHolderImageOrange } from '../../'

export const useImageFaceBase = (props: FaceProps) => {
  const { token, viewMode } = props
  const icon = viewMode === 'icon'
  const resizeMode = icon ? 'cover' : 'contain'
  const tokenImage = token?.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')
  const tokenAnimationUrl = token?.metadata.animation_url
  const [img, setImage] = useState<string | undefined>(tokenImage)

  const getVideoGif = (url: string) => {
    const encode = encodeURIComponent(url)
    return `https://resources.vatom.com/video-to-gif?url=${encode}`
  }

  const style = StyleSheet.create({
    img: {
      width: '100%',
      height: '100%',
      resizeMode,
      borderTopLeftRadius: icon ? 8 : 0,
      borderTopRightRadius: icon ? 8 : 0,
      // opacity: isLoading ? 0 : 1,
      objectFit: 'contain'
    }
  })

  const setFace = useCallback(async () => {
    let image = tokenImage
    const animation_url = tokenAnimationUrl || placeHolderImageOrange
    const mime_animation_url = (await Utils.getMimeType(animation_url)) || ''
    const viewMode = props.viewMode
    if (!icon && token.type === 'vatom' && viewMode) {
      const vatom = token as any
      const face = vatom.getFace(viewMode)
      const resourceName =
        face?.properties.config.image || face?.properties.resources[0] || 'ActivatedImage'
      const resource = vatom.getResource(resourceName)
      image = resource?.url ?? image
    }

    if (image && Utils.validateUrl(image)) {
      setImage(image)
    } else if (
      !image &&
      animation_url &&
      Utils.allImgSupported.includes(mime_animation_url) &&
      Utils.validateUrl(mime_animation_url)
    ) {
      setImage(getVideoGif(animation_url))
    } else {
      setImage(placeHolderImageOrange)
    }
  }, [tokenImage, tokenAnimationUrl, token, icon, props.viewMode])

  useEffect(() => {
    setFace()
  }, [setFace])

  return {
    img,
    style
  }
}
